const state = {
  listSecurityQuestions: [],
  currentSecurityQuestion: {},
  notificationSettings: {}
}

export default state
